import React from 'react'
import { Container } from '@material-ui/core';
import { connect } from 'react-redux'
import Config from '../../config/Configs';
import logo from '../../logo.svg';

const PageLink = ({language}) => {
  const {about, contact, needHelp}= language;
  return (
    <div className="top-bar-nav-outer clearfix">
    <Container className="top-bar-nav">
    <div className="logo"><a  href="https://www.matildaeducation.com.au"  target='_blank'> <img src={logo} alt="Matilda" /></a></div>
    <div className="top-right-links-nav">
      <a href={Config.aboutUrl} rel="noopener noreferrer" target='_blank'>{about} </a>
      <a href={Config.helpUrl} rel="noopener noreferrer" target='_blank'>{needHelp} </a>
      <a href={Config.contactUrl} rel="noopener noreferrer" target='_blank'>{contact} </a>
      </div>
    </Container>
    </div>
  )
}
const mapStateToProps = (state) => {
  const {about, contact, needHelp}= state.Language
  return {
      language :{about, contact, needHelp}
  }
}

export default connect(mapStateToProps)(PageLink)
